export const getLogsApi = ( apiInstance: API.Client ) => ( siteIds: string[] ) => (
  apiInstance.Entity.collection( "dataLog" )
    .getQuery( {
      "entity.name": "patrol",
      "n.site.uid": siteIds.length > 0
        ? { $in: siteIds }
        : undefined
    } )
);
